
import React from "react";

interface DashboardWelcomeProps {
  title: string;
  subtitle: string;
}

const DashboardWelcome: React.FC<DashboardWelcomeProps> = ({ title, subtitle }) => {
  return (
    <div>
      <h2 className="text-2xl md:text-3xl font-bold">{title}</h2>
      <p className="text-gray-600">{subtitle}</p>
    </div>
  );
};

export default DashboardWelcome;
